var _defs, _rect, _rect2, _rect3, _g, _rect4, _rect5, _path, _rect6, _rect7, _rect8, _rect9, _path2, _rect10;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOneNote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D5134EB3-BE44-40D1-B98B-72BB34BB975C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.357002%",
    y1: "-4.44071681%",
    x2: "82.642998%",
    y2: "104.440717%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.5,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.7,
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "UI-Kit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CMHC_UI-Kit_Iconography",
    transform: "translate(-404.000000, -3507.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-microsoft-office-/-one-note",
    transform: "translate(404.000000, 3507.000000)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "_142",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ambient-2",
    transform: "translate(9.194936, 1.681147)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("image", {
    id: "Bitmap",
    style: {
      mixBlendMode: "multiply"
    },
    x: 0.907774566,
    y: 0.408419863,
    width: 29.1858087,
    height: 33.0849756,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABTCAYAAAA8/EEfAAAABGdBTUEAALGOfPtRkwAAAHhlWElmTU0AKgAAAAgABAEaAAUAAAABAAAAPgEbAAUAAAABAAAARgEoAAMAAAABAAIAAIdpAAQAAAABAAAATgAAAAAAAAEsAAAAAQAAASwAAAABAAOgAQADAAAAAQABAACgAgAEAAAAAQAAAEigAwAEAAAAAQAAAFMAAAAA0m2kYAAAAAlwSFlzAAAuIwAALiMBeKU/dgAAAm1JREFUeAHtnMErRFEYxQ0TsUDKgkhZKVnb2PnXp4Q/w4giZYlhnPN69/WG4Vd23jtfne5779ymvl/n3tl9g+l0utCugar93pdncZgFUTc+KN9rMEN9X5aWpL6AMph36VWafAVVAarhrGjDtrQnbUh9gFTgPKvfsfQgvbQhOTEur4ZzKp1J+5KT1Idycm6kkXQp3UtvUlXDOj2G4eQYzrm0IxV4eux0TdTdXd3hrdYnMWmOWoHg4+Rj5eQYzqa0KPWhPuom3Xu5Wpq+CyBfyH52krwaTl8uaffa7n2m776kRAz+VgEE3AIogIAA2ElQAAEBsJOgAAICYCdBAQQEwE6CAggIgJ0EBRAQADsJCiAgAHYSFEBAAOwkKICAANhJUAABAbCToAACAmAnQQEEBMBOggIICICdBAUQEAA7CQogIAB2EhRAQADsJCiAgADYSVAAAQGwk6AAAgJgJ0EBBATAToICCAiAnQQFEBAAOwkKICAAdhIUQEAA7CQogIAA2ElQAAEBsJOgAAICYCdBAQQEwE6CAggIgJ0EBRAQADsJCiAgAHYSFEBAAOwkKICAANglQR646HF51TRKrXPHdsJv/Vf7197LFDyP6vQ0Sg9c9KBFf1+TPD5wZiqc3rtUhvMiPUpjyQzMoqmhx3JqsKKT4w0jyXCOpQNpvX7X0snyqTGcK+lCMoPX9qjSebNcD7XpSDqRPHSyyyNLSzAM51ryJM6ZWa7zpgGvatOWtCs5QV09Zj5e5Wpxcr4NutW3hQaQX1w6br64DcXJ6SoctVZVgVT9ObWPVtnwDVBjiFR57vo6D0zp+UdAZUPf10/nzoNhdXBTIgAAAABJRU5ErkJggg=="
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 2.34651161,
    y: 0.576534577,
    width: 26.0514173,
    height: 30.3110829,
    rx: 0.84
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.12,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(1.081757, 0.000000)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Bitmap",
    style: {
      mixBlendMode: "multiply"
    },
    x: 0.494002445,
    y: 0.257116621,
    width: 27.5415378,
    height: 31.4710744,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABPCAYAAABS1GNxAAAABGdBTUEAALGOfPtRkwAAAHhlWElmTU0AKgAAAAgABAEaAAUAAAABAAAAPgEbAAUAAAABAAAARgEoAAMAAAABAAIAAIdpAAQAAAABAAAATgAAAAAAAAEsAAAAAQAAFjgAAAATAAOgAQADAAAAAQABAACgAgAEAAAAAQAAAESgAwAEAAAAAQAAAE8AAAAARALk5AAAAAlwSFlzAAAuIwAALgoBPOOgnQAAAa1JREFUeAHt3LFNA0EURVEWIbkJMjdBRkZDZBRARkFkDqmACGcuAqLlv9F6WV+ogH9HGo3fyMkcPTv80zzPV1nTNO3quK2ds8v6qoeeyiDnWFNAFoy7unmqHZQu61QPfa79tqIsDdnX5Wvtz9qpTJed9x5q39feLRbjJ/JQFx+1u0Bs3xmUlGEfkOv6kJ/I43LW0W5d/HcG5OKiHQceHBDXRkCQDUY+CiIIBBBtiCAQQLQhgkAA0YYIAgFEGyIIBBBtiCAQQLQhgkAA0YYIAgFEGyIIBBBtiCAQQLQhgkAA0YYIAgFEGyIIBBBtiCAQQLQhgkAA0YYIAgFEGyIIBBBtiCAQQLQhgkAA0YYIAgFEGyIIBBBtiCAQQLQhgkAA0YYIAgFEGyIIBBBtiCAQQLQhgkAA0YYIAgFEGyIIBBBtiCAQQLQhgkAA0YYIAgFEG/IHyBhuVvfrcDN857/HX+/PUKbOY7syrizvH3PMbjLhrSbdHevivXZWxnh1GP93bkbefYxDHr8d/ReITLzrMtMsY/9eaqcM6zzEAVIXYzUbEDkacm7GapBxd64fgW8Khwf2/qciSAAAAABJRU5ErkJggg=="
  }), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 1.26475444,
    y: 0.576534577,
    width: 26.0514173,
    height: 30.3110829,
    rx: 0.84
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ambient-3",
    transform: "translate(10.907718, 1.681147)",
    fill: "#CA64EA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5955524,30.8540972 L2.07246646,30.8540972 C1.68948527,30.8585514 1.32083317,30.7112341 1.05000467,30.4454078 C0.779176172,30.1795815 0.629086704,29.8177384 0.633624821,29.4418309 L0.633624821,1.98869817 C0.629086704,1.61279063 0.779176172,1.25094753 1.05000467,0.985121235 C1.32083317,0.719294935 1.68948527,0.571977617 2.07246646,0.576431916 L25.2292818,0.576431916 C25.612263,0.571977617 25.9809151,0.719294935 26.2517436,0.985121235 C26.5225721,1.25094753 26.6726616,1.61279063 26.6681235,1.98869817 L26.6681235,28.8870523 C26.6223601,29.9803536 25.7103322,30.8459436 24.5955524,30.8540972 L24.5955524,30.8540972 Z",
    id: "Path"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#AE4BD5",
    fillRule: "nonzero",
    x: 29.8682172,
    y: 9.82284382,
    width: 7.72464772,
    height: 7.58197358
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#9332BF",
    fillRule: "nonzero",
    x: 29.8682172,
    y: 17.4048174,
    width: 7.72464772,
    height: 7.58197358
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8682172,24.986791 L37.5928649,24.986791 L37.5928649,31.1397895 C37.5928649,31.9289906 36.941052,32.5687646 36.137,32.5687646 L29.8682172,32.5687646 L29.8682172,24.986791 Z",
    id: "Path",
    fill: "#7719AA",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ambient-4",
    transform: "translate(0.000000, 6.724589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.48,
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("image", {
    id: "Bitmap",
    style: {
      mixBlendMode: "multiply"
    },
    x: 0.528258089,
    y: 0.0890019072,
    width: 24.252996,
    height: 23.8050434,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAABGdBTUEAALGOfPtRkwAAAHhlWElmTU0AKgAAAAgABAEaAAUAAAABAAAAPgEbAAUAAAABAAAARgEoAAMAAAABAAIAAIdpAAQAAAABAAAATgAAAAAAAAEsAAAAAQAAASwAAAABAAOgAQADAAAAAQABAACgAgAEAAAAAQAAADygAwAEAAAAAQAAADwAAAAA3rOtQAAAAAlwSFlzAAAuIwAALiMBeKU/dgAABLJJREFUaAXtmolu2zAQRJ3e932g//91RZui6X0mnUdr5BVNialjS1GrBbakeGkfZ+kUEI/Ozs5W/5Nd2wX2SLbLvH3OkVA7KXU0NC+ARcBY3yfDLmsZOpXn2YRe4AYWuCtyylh3cFPAR0jq+GlTpuch8CKwYIG0X1U9etyAqYAN+lux5Q78aR/01hkOsPRdl98IThvuzVA1KU85hgGKAQXoL/lP+Y/gPK/EUYTuADdpDAztN+W35Hfkd+W35bSxASgeldbjKGZlAQYW0K/yL8HJOtqL0C1wA+tzirIA3pc/bPyBSuDZBPqBjikd6+raq1lZFrW6KAnsJ/kH+Xs5MWHeGJfrVv3bAjctVhcVgQP2ufyZ/EnzzEZElfU4mhkAdb/LP8tP5Mdys8QzfYqQ8Tx7kMa3v8TsEqlLGj+SA/xK/kL+WH5PDjBzUfWQymr5jgHsdAb4o/ydnHgxbwR9pDXPHYvAdKAwwAChJGn8VP5SDjR10pwXOKWnAEbFb3JSmSOGAYnibAIl8cHDBrFRyXJggmcgZ5SFUBlolCWt8amBCR7lALay1Eltsg+hSr8xam7yPvxgARxV9q80C+HAXgZgFCYLMZQlJv8l8XErZmCuMAtEaPrZLRZhN6MXF9SYQ5p/tADGOKeI4riIlZg7scUfrhzY55EygrOA3Qt6UXWNaj6PvN+xULpOhuJmUXVjDMrNsHkZF4p9+fwxnuP7Y1wR1GM68TDgPMbkaPlz7Bujbpi85N1uK8ZRA54arBj0RRprwBdZe4q5VYH+NeDqJi/A1S2a+YBF4ZkLWA1/Ubi6RTMfsCg8cwGr4S8KV7do5gMWhWcuYDX8ReHqFs18wKLwzAWshr8oXN2imQ9YFJ65gNXwF4WrW3S5B/gzTG+UNYWrC/SufEk7asAOOwfPnz1urJL3l5z3u70YS+ljWj7JcF4olsVFD9wY30+dL/z+yu+SEDyOems5sAe59GLxoojrLDL44ap9y/4qjssxcBOAOqXrjpmxW5YDMyAuyiJcD/LlL762+8v7FN+HY2xcc7ATF06cBvfY1dYtHhr0lVxjEyw75F1jERblkgjuCyR8eZ8SGCji4lIL7oss3Nvy7R0YWmjVk0WF3QkwOwUsN9xYjEtfXBbBeBEqTwVsQQz8VrFwdYlLLVxSA5r4DazqxiIwrUAzkAmGjfegWIzLI74lo2r5agEdBzDiAxiFEQQxiO+1/FiO2sSNynAwljmtRWAvxkCry675zNKG0qQ1wPxJq36P1Zh9GjHiBuaYESOwb+TEF4E7sOpLF0EobV6MHWIiC2A8s3tcR+TGDBsV/4YfGjwG7pQmC8k40pjYiDVXmJ+nOHcDTAfXEjUpprQe024Cz04a1uf30KC8Pxrx4U5rhACa+OycbTZjK53VtupcEA8X1AAibXHf0fJzhJ0CWCElGIQhtYED3M5zOr+5umrvAqeG9d8nQEhZ4EhfSpw2n92xYfXqZFbZ2QhcdJQtXg5ndkdhGrCgNFCGd92gLtOcEf8BFIvgTt/UVlJ2PaUHuO1cq82j4Vx6yNRlhO/8j6ovsKLCfYNpb9QfGjJK35CKQwH8NfDQYnPoi39L5xDvhWP8A026r3wLq0TdAAAAAElFTkSuQmCC"
  }), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 3.81679991,
    y: 2.15681288,
    width: 17.3676115,
    height: 17.046832,
    rx: 0.85
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.24,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(3.370090, 1.618987)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Bitmap",
    style: {
      mixBlendMode: "multiply"
    },
    x: 0.00138686818,
    y: 0.0502931412,
    width: 18.4980478,
    height: 18.1563891,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAYAAABXuSs3AAAABGdBTUEAALGOfPtRkwAAAHhlWElmTU0AKgAAAAgABAEaAAUAAAABAAAAPgEbAAUAAAABAAAARgEoAAMAAAABAAIAAIdpAAQAAAABAAAATgAAAAAAAAzwAAAACwAADPAAAAALAAOgAQADAAAAAQABAACgAgAEAAAAAQAAAC6gAwAEAAAAAQAAAC4AAAAAGePEcgAAAAlwSFlzAAAuTgAALk4BHJw2GAAAAQJJREFUaAXtmbENwkAUQ+8QUpagS8cEdOzFAOxER5kF2CBDQHXYgUi4pbBykr/kXHyNraek+rW1VmqtQynlAPHc4rxQakZXnstUPFn2BF0glt/izCh1habf8iMubtATahsVu92hMzTwK+EcoQe01dJrL5Yn4JHFd3jpZeQ/7Km4AE5xwWEwIW6ALBEhLjgMJsQNkCUixAWHwYS4AbJEhLjgMJgQN0CWiBAXHAYT4gbIEhHigsNgQtwAWSJCXHAYTIgbIEtEiAsOgwlxA2SJCHHBYTAhboC8LGmRsyxpSVwuDAX+iWDHCeKSlsvasv++8ILTzWa5ctnZ5S5/XS9/gPfzfANxTodLWKK/ogAAAABJRU5ErkJggg=="
  }), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 0.44671024,
    y: 0.537825811,
    width: 17.3676115,
    height: 17.046832,
    rx: 0.85
  })))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#7719AA",
    fillRule: "nonzero",
    x: 3.81679991,
    y: 8.88140143,
    width: 17.3676115,
    height: 17.046832,
    rx: 0.85
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light"
    },
    transform: "translate(3.425564, 8.405736)",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.391235513,
    y: 0.475665748,
    width: 17.3676115,
    height: 17.046832,
    rx: 0.85
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57833443,12.7816628 L10.5309061,12.7816628 L14.3332826,18.9178498 C14.4803497,19.1269033 14.6119987,19.3460112 14.7272225,19.5734972 L14.7272225,19.5734972 C14.7013834,19.153593 14.7013834,18.732541 14.7272225,18.3126369 L14.7272225,12.7816628 L16.4400047,12.7816628 L16.4400047,22.027972 L14.5902,22.027972 L10.5994174,15.7236703 C10.4582602,15.5229444 10.3377735,15.3089478 10.2397332,15.0848344 L10.2397332,15.0848344 C10.2642956,15.5440317 10.2642956,16.0041777 10.2397332,16.463375 L10.2397332,22.027972 L8.52695097,22.027972 L8.57833443,12.7816628 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 3.81679991,
    y: 0.357985449,
    width: 34.735223,
    height: 34.0936639
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneNote);
export default __webpack_public_path__ + "static/media/OneNote.442b3ca736b3ad5d6e5db437420b2642.svg";
export { ForwardRef as ReactComponent };